import { numberSplitFloat as numberMoneyToChineseMoney } from 'public/utils'

export function formatMoneyUnit(val) {
  const units = [
    { value: 1e12, unit: '万亿' },
    { value: 1e11, unit: '千亿' },
    { value: 1e10, unit: '百亿' },
    { value: 1e9, unit: '十亿' },
    { value: 1e8, unit: '亿' },
    { value: 1e7, unit: '千万' },
    { value: 1e6, unit: '百万' },
    { value: 1e5, unit: '十万' },
    { value: 1e4, unit: '万' },
    { value: 1e3, unit: '千' },
    { value: 1e2, unit: '百' },
  ]
  for (const unit of units) {
    if (val >= unit.value) {
      return unit.value >= 1e2 ? unit.unit : unit.unit[1]
    }
  }
  return ''
}

export const CHINESE_MONEY = 'chineseCurrency'
export const THOUSANDS_SEPARATOR = 'thousandsSeparator'
export function formatMoney({ value, type = CHINESE_MONEY, decimal, customTranslateMoney } = {}) {
  if (!value && value !== 0) return ''
  if (typeof customTranslateMoney === 'function') return customTranslateMoney(value)
  if (type === CHINESE_MONEY) {
    return numberMoneyToChineseMoney(value, decimal)
  } else {
    return formatMoneySeparators(value, decimal)
  }
}

export function formatMoneySeparators(number = 0, decimal = 2) {
  if (number === '') return number
  const toNumberVal = Number(number)
  if (isNaN(toNumberVal)) {
    return number
  }
  const parts = truncateDecimals(toNumberVal, decimal).toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export function truncateDecimals(number, decimal) {
  number = Number(number)
  return number
}




// WEBPACK FOOTER //
// ./src/public/components/kye-input-money/tools.js